import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { PosTerminalsService } from 'src/app/services/pos-terminals.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-pos-terminals',
  templateUrl: './pos-terminals.component.html',
  styleUrls: ['./pos-terminals.component.scss'],
})
export class PosTerminalsComponent implements OnInit {
  storeId: string = '';
  terminals: any[] = [];
  storesPage: number = 1;
  storesWord: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private posTerminalsService: PosTerminalsService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.storeId = this.route.snapshot.paramMap.get('id') || '';
    this.storesPage = +this.route.snapshot.queryParamMap.get('storesPage')! || 1;
    this.storesWord = this.route.snapshot.queryParamMap.get('storesWord') || '';
    this.loadTerminals();
  }

  loadTerminals(): void {
    this.spinner.show();
    this.posTerminalsService.getTerminals(this.storeId).subscribe({
      next: (res: any) => {
        this.terminals = res.response?.data?.terminals || [];
        this.spinner.hide();
      },
      error: (err: any) => {
        this.toastr.error(err.error?.response?.message || 'Failed to load terminals');
        this.spinner.hide();
      },
    });
  }

  onCreate(): void {
    this.router.navigate(['/store', this.storeId, 'pos-terminals', 'new']);
  }

  onEdit(terminal: any): void {
    this.router.navigate(['/store', this.storeId, 'pos-terminals', terminal._id, 'edit']);
  }

  onDelete(terminal: any): void {
    Swal.fire({
      title: 'Disable Terminal?',
      text: `This will disable "${terminal.terminalName}". The terminal cannot be disabled if it has an active session.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, disable it',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        this.spinner.show();
        this.posTerminalsService.deleteTerminal(this.storeId, terminal._id).subscribe({
          next: (res: any) => {
            this.toastr.success('Terminal disabled successfully');
            this.spinner.hide();
            this.loadTerminals();
          },
          error: (err: any) => {
            this.spinner.hide();
            const status = err.status;
            if (status === 400) {
              this.toastr.error('Cannot disable: terminal has an active session');
            } else {
              this.toastr.error(err.error?.response?.message || 'Failed to disable terminal');
            }
          },
        });
      }
    });
  }

  onBackToStores(): void {
    this.router.navigate(['/stores'], {
      queryParams: {
        page: this.storesPage > 1 ? this.storesPage : null,
        word: this.storesWord || null,
      },
    });
  }

  scannerLabel(type: string): string {
    return type === 'camera' ? 'Camera' : 'External';
  }

  paymentLabel(method: string): string {
    return method === 'cardTerminal' ? 'Card Terminal' : 'Customer Device';
  }
}
